import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const MedioPagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [tiposDocumentoIdentidad, setTiposDocumentoIdentificacion] = React.useState([])

  React.useEffect(() => {
    TablaComunService.getAsSelect(TiposTablaComunConstant.DOCUMENTOSIDENTIDAD).then(({ data }) =>
      setTiposDocumentoIdentificacion(data)
    )
  }, [])

  return (
    <Form.Group>
      <Form.Label
        text='TIPO DOC'
        htmlFor='select-tipoDocumentoIdentificacion'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        <Field name='tipoDocumentoIdentificacion'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-tipoDocumentoIdentificacion'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {tiposDocumentoIdentidad.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MedioPagoFormGroup)
